import {IUserPreferencesNamesResolver} from '../../@interfaces/services/NameResolvers/IUserPreferencesNamesResolver';
import {UserPreferencesKeys} from '../../@types/services/UserPreferencesNamesResolver';
import {snake_case} from '../../helpers/string-registres';

export default class UserPreferencesNamesResolver implements IUserPreferencesNamesResolver {
    protected nameMutator?: (name: string) => string = undefined;

    getSearchTermName(controllerName: string): string {
        return this.resolveName(controllerName, UserPreferencesKeys.SEARCH_TERM);
    }

    getSortByName(controllerName: string): string {
        return this.resolveName(controllerName, UserPreferencesKeys.SORT_BY);
    }

    getListColumnsOrderName(controllerName: string): string {
        return this.resolveName(controllerName, UserPreferencesKeys.LIST_COLUMNS_ORDER);
    }

    getListColumnsVisibilityName(controllerName: string): string {
        return this.resolveName(controllerName, UserPreferencesKeys.LIST_COLUMNS_VISIBILITY);
    }

    getListRecordsPerPageName(controllerName: string): string {
        return this.resolveName(controllerName, UserPreferencesKeys.LIST_RECORDS_PER_PAGE);
    }

    getListPaginationDisabledName(controllerName: string): string {
        return this.resolveName(controllerName, UserPreferencesKeys.LIST_PAGINATION_DISABLED);
    }

    resolveName(controllerName: string, key: UserPreferencesKeys): string {
        const result = `${snake_case(controllerName, '-')}.${key}`;

        return this.nameMutator ? this.nameMutator(result) : result;
    }

    withNameMutator<T>(
        mutator: null | undefined | ((name: string) => string),
        callback: (service: IUserPreferencesNamesResolver) => T,
    ): T {
        try {
            this.nameMutator = mutator ?? undefined;
            return callback(this);
        } finally {
            this.nameMutator = undefined;
        }
    }
}
